import Box from '@mui/material/Box'
import { themeConfig } from '@gap/shared/theme'

export function GroupHeader({ children }: { children: React.ReactNode }) {
   return <Box
      sx={{
         padding: '8px 16px 6px',
         fontSize: 11,
         fontWeight: 500,
         textTransform: 'uppercase',
         letterSpacing: '0.5px',
         color: themeConfig.primary[500],
      }}
   >
      {children}
   </Box>
}

export function GroupDivider() {
   return <Box
      sx={{
         height: 1,
         background: themeConfig.primary[200],
         margin: '4px 8px',
      }}
   />
}
